import { ApolloError } from '@apollo/client';

const alreadyCommittedRegex = /already been committed|already committed/i;

export const isAlreadyCommittedCommitError = (error?: ApolloError | null): boolean => {
  if (!error) {
    return false;
  }

  if (alreadyCommittedRegex.test(error.message)) {
    return true;
  }

  return error.graphQLErrors?.some(graphQLError =>
    alreadyCommittedRegex.test(graphQLError.message)
  );
};
